import NewsItem from "./NewsItem";
import '../css/Home.css';
import { useEffect, useState } from "react";
import {getPlaylist, getPosts} from '../rest/RestAPI';
import Playlist from "./Playlist";

export default function Home() {
    const [posts, setPosts] = useState([]);
    const [playlist, setPlaylist] = useState([]);
    useEffect(() => {
    async function fetchPosts() {
      const res = await getPosts();
      setPosts(res);
    }
    setPlaylist(getPlaylist());
    fetchPosts();
    }, []);
    return (
      <div className='Home'>
        <div className='home1'>
          <Playlist playlist={playlist} />
        </div>
        <div className='home2'>
        {posts.map(post => {
            return <NewsItem key={post.id} post={post} />
        })}
        </div>
      </div>
    );
  }